module.exports = __webpack_public_path__ + "static/sourcecode-fb7113aa911b11fac20a4a760826c170.mp4";